import { Box } from "@material-ui/core";
import React from "react";

const CustomPopperUI = ({ children, className, rest ,addTaskPosition,modalHeight,modalWidth}) => {
  return (
    <div
      id="custom_modal_common"
      className={`custom_modal ${className}`}
      {...rest}
    >
      <Box id="custom_modal-content" className="custom_popper_content"
      
      style={{
        top: `${addTaskPosition?addTaskPosition.bottom+(0.5*modalHeight):340}px`,
        left: `${addTaskPosition?addTaskPosition.left+(0.5*modalWidth):340}px`,
        // top: `${addTaskPosition?addTaskPosition.bottom:340}px`,
        // left: `${addTaskPosition?addTaskPosition.left:340}px`,
      }}
      
      >
        {children}
      </Box>
    </div>
  );
};

export default CustomPopperUI;
